import type { ReactNode } from 'react';

import { subscriptionFormOptions } from '@/entities/(notification)/subscription';
import { withForm } from '@/shared/ui/form';

import { SubscriptionFormPanel } from './subscription-form-panel';

export const SubscriptionFormContent = withForm({
  ...subscriptionFormOptions,
  props: {
    workspaceId: '',
    renderFooter: undefined as (() => ReactNode) | undefined,
  },
  render: function SubscriptionFormContent({
    form,
    workspaceId,
    renderFooter,
  }) {
    return (
      <div className="px-4 pb-6">
        <SubscriptionFormPanel
          form={form}
          workspaceId={workspaceId}
          renderFooter={renderFooter}
        />
      </div>
    );
  },
});
